import React, { Component, ErrorInfo, ReactNode } from "react";
import ClientEventEndpoints from "../../lib/ClientEvent/ClientEventEndpoints";
import { Icon } from 'semantic-ui-react';
interface Props {
    children: ReactNode;
}
  
interface State {
    hasError: boolean;
}
class ErrorHandler extends  Component<Props, State> {
    static defaultProps = {
        hasError: false
    }

    async LogErrorEvent(error: Error, errorInfo: ErrorInfo) {
        await ClientEventEndpoints.logClientError(error, errorInfo);
    }

    public static getDerivedStateFromError(_: Error): State {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
      }
    
    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("Uncaught error:", error, errorInfo);
        this.LogErrorEvent(error,errorInfo);
    }

    render() {
        if (this.state?.hasError== true) {
            return (
            <div style={{display:"flex"}}>
            <Icon 
                name="exclamation circle" 
                size={"huge"}
            />
            <span><h1>Oj, något gick fel, kontakta IT.</h1></span>
            </div>)

        }
        return this.props.children; 
    }
}

export default ErrorHandler;